export default "__VITE_ASSET__a0f570af__"